import React from 'react';
import _ from 'lodash';

import Master from '../../Components/Master';
import Dialog from '../../Components/Dialog';
import Table from '../../Components/Table';
import Loader from '../../Components/Loader';

import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux'
import { doPost, doLoad, doPut, select, doDelete } from '../../Redux/Actions'
import store from '../../Redux';

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Toolbar from '@material-ui/core/Toolbar';
import TextField from '@material-ui/core/TextField';

import ChangeHistory from '@material-ui/icons/ChangeHistory';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';

const ENDPOINT = "command"

const styles = theme => ({

})

class ListObject extends Master {

    state = {
        ...this.state,
        isLoading: true,
        dialogOpen: false,
        newEntry: {},
        route: "/" + ENDPOINT
    }

    sendcommand = () => {
        this.props.doPost(this.state.newEntry)
    }

    render() {

        var isLoading = false

        if(isLoading) {
            return (
                <Loader />
            )
        }

        console.log("OK")

        return (
            <div>

                <TextField
                    placeholder="Kommando..."
                    type="text"
                    margin="normal"
                    fullWidth
                    autoFocus
                    multiline
                    onChange={this.handleChange('command')}
                />

                <Button variant="fab" className="fab" onClick={this.sendcommand} color={"primary"}>
                    <ChangeHistory />
                </Button>

            </div>
        )
    }

}

const mapStateToProps = state => ({
    [ENDPOINT]: state[ENDPOINT],
})

const mapDispatchToProps = (dispatch, ownProps) => ({
    doPost: (data) => dispatch(doPost(ENDPOINT, "api/generic/"+ENDPOINT, data)),
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(ListObject));



// WEBPACK FOOTER //
// ./src/Routes/SqlCommand/index.js